<div class="mercadopago-3ds-settings">
  <div class="page-header">
    <div class="page-title">3DS Mercado Pago</div>
    <p class="page-description">
      Liga ou desliga o desafio 3DS Mercado Pago em dois fluxos separados:
      <strong>Pagar agora</strong> (retenção) e
      <strong>novas assinaturas</strong> (aquisição / reativação).
    </p>
    <div class="fallback-note">
      <i class="pi pi-info-circle"></i>
      <span>
        Os toggles são independentes. Não alteram Pix, ZDA, upgrade nem o robô.
        A alteração só vale depois de clicar em Salvar.
      </span>
    </div>
  </div>

  @if (retentionConfig) {
    <div class="config-card">
      <div class="config-card__header">
        <div>
          <h2>Pagar agora</h2>
          <p>
            Retenção — CTA Pagar agora com cartão Mercado Pago
            (<code>MercadoPagoRetentionThreeDs</code>).
          </p>
        </div>
      </div>

      <div class="toggle-row">
        <div class="toggle-row__copy">
          <strong>{{ retentionConfig.name }}</strong>
          <small>{{ retentionConfig.description }}</small>
        </div>
        <p-inputSwitch
          [formControl]="retentionEnabledControl"
          [disabled]="savingRetention"
        />
      </div>

      <div class="config-card__footer">
        <small class="config-card__updated">
          @if (retentionConfig.dateUpdated) {
            <i class="pi pi-clock"></i>
            Última atualização:
            {{ retentionConfig.dateUpdated | date: 'dd/MM/yyyy HH:mm' }}
            @if (retentionConfig.updatedBy) {
              <span> por {{ retentionConfig.updatedBy }}</span>
            }
          }
        </small>
        <p-button
          label="Salvar"
          icon="pi pi-check"
          (onClick)="saveRetention()"
          [loading]="savingRetention"
          [disabled]="savingRetention || !retentionDirty"
        />
      </div>
    </div>
  }

  @if (acquisitionConfig) {
    <div class="config-card">
      <div class="config-card__header">
        <div>
          <h2>Novas assinaturas</h2>
          <p>
            Aquisição e reativação no checkout / create
            (<code>MercadoPagoAcquisitionThreeDs</code>).
          </p>
        </div>
      </div>

      <div class="toggle-row">
        <div class="toggle-row__copy">
          <strong>{{ acquisitionConfig.name }}</strong>
          <small>{{ acquisitionConfig.description }}</small>
        </div>
        <p-inputSwitch
          [formControl]="acquisitionEnabledControl"
          [disabled]="savingAcquisition"
        />
      </div>

      <div class="config-card__footer">
        <small class="config-card__updated">
          @if (acquisitionConfig.dateUpdated) {
            <i class="pi pi-clock"></i>
            Última atualização:
            {{ acquisitionConfig.dateUpdated | date: 'dd/MM/yyyy HH:mm' }}
            @if (acquisitionConfig.updatedBy) {
              <span> por {{ acquisitionConfig.updatedBy }}</span>
            }
          }
        </small>
        <p-button
          label="Salvar"
          icon="pi pi-check"
          (onClick)="saveAcquisition()"
          [loading]="savingAcquisition"
          [disabled]="savingAcquisition || !acquisitionDirty"
        />
      </div>
    </div>
  }
</div>
<p-toast />
